// src/borderWidth.ts
var borderWidth = {
  0: 0,
  1: "var(--carotene-border-width-1)"
};

// src/color.ts
var color = {
  fg: {
    onSolid: "var(--carotene-color-fg-on-solid)",
    neutral: "var(--carotene-color-fg-neutral)",
    neutralSubtle: "var(--carotene-color-fg-neutral-subtle)",
    neutralMuted: "var(--carotene-color-fg-neutral-muted)",
    neutralHover: "var(--carotene-color-fg-neutral-hover)",
    neutralPressed: "var(--carotene-color-fg-neutral-pressed)",
    brand: "var(--carotene-color-fg-brand)",
    brandHover: "var(--carotene-color-fg-brand-hover)",
    negative: "var(--carotene-color-fg-negative)",
    positive: "var(--carotene-color-fg-positive)",
    warning: "var(--carotene-color-fg-warning)",
    placeholder: "var(--carotene-color-fg-placeholder)",
    neutralInverted: "var(--carotene-color-fg-neutral-inverted)",
    disabled: "var(--carotene-color-fg-disabled)"
  },
  bg: {
    brandSolid: "var(--carotene-color-bg-brand-solid)",
    brandWeak: "var(--carotene-color-bg-brand-weak)",
    positiveSolid: "var(--carotene-color-bg-positive-solid)",
    positiveWeak: "var(--carotene-color-bg-positive-weak)",
    warningSolid: "var(--carotene-color-bg-warning-solid)",
    warningWeak: "var(--carotene-color-bg-warning-weak)",
    negativeSolid: "var(--carotene-color-bg-negative-solid)",
    negativeWeak: "var(--carotene-color-bg-negative-weak)",
    disabled: "var(--carotene-color-bg-disabled)",
    layerDefault: "var(--carotene-color-bg-layer-default)",
    brandSolidHover: "var(--carotene-color-bg-brand-solid-hover)",
    brandSolidPressed: "var(--carotene-color-bg-brand-solid-pressed)",
    brandWeakHover: "var(--carotene-color-bg-brand-weak-hover)",
    brandWeakPressed: "var(--carotene-color-bg-brand-weak-pressed)",
    layerDefaultHover: "var(--carotene-color-bg-layer-default-hover)",
    layerDefaultPressed: "var(--carotene-color-bg-layer-default-pressed)",
    layerElevated: "var(--carotene-color-bg-layer-elevated)",
    layerElevatedHover: "var(--carotene-color-bg-layer-elevated-hover)",
    layerElevatedPressed: "var(--carotene-color-bg-layer-elevated-pressed)",
    neutral: "var(--carotene-color-bg-neutral)",
    neutralHover: "var(--carotene-color-bg-neutral-hover)",
    neutralPressed: "var(--carotene-color-bg-neutral-pressed)",
    neutralInverted: "var(--carotene-color-bg-neutral-inverted)",
    neutralInvertedHover: "var(--carotene-color-bg-neutral-inverted-hover)",
    overlay: "var(--carotene-color-bg-overlay)"
  },
  stroke: {
    decorative: "var(--carotene-color-stroke-decorative)",
    control: "var(--carotene-color-stroke-control)",
    field: "var(--carotene-color-stroke-field)",
    fieldFocused: "var(--carotene-color-stroke-field-focused)",
    brand: "var(--carotene-color-stroke-brand)",
    negative: "var(--carotene-color-stroke-negative)"
  },
  palette: {
    gray00: "var(--carotene-color-palette-gray-00)",
    gray100: "var(--carotene-color-palette-gray-100)",
    gray200: "var(--carotene-color-palette-gray-200)",
    gray300: "var(--carotene-color-palette-gray-300)",
    gray400: "var(--carotene-color-palette-gray-400)",
    gray500: "var(--carotene-color-palette-gray-500)",
    gray600: "var(--carotene-color-palette-gray-600)",
    gray700: "var(--carotene-color-palette-gray-700)",
    gray800: "var(--carotene-color-palette-gray-800)",
    gray900: "var(--carotene-color-palette-gray-900)",
    carrot100: "var(--carotene-color-palette-carrot-100)",
    carrot200: "var(--carotene-color-palette-carrot-200)",
    carrot300: "var(--carotene-color-palette-carrot-300)",
    carrot400: "var(--carotene-color-palette-carrot-400)",
    carrot500: "var(--carotene-color-palette-carrot-500)",
    carrot600: "var(--carotene-color-palette-carrot-600)",
    carrot700: "var(--carotene-color-palette-carrot-700)",
    carrot800: "var(--carotene-color-palette-carrot-800)",
    carrot900: "var(--carotene-color-palette-carrot-900)",
    carrot1000: "var(--carotene-color-palette-carrot-1000)",
    blue100: "var(--carotene-color-palette-blue-100)",
    blue200: "var(--carotene-color-palette-blue-200)",
    blue300: "var(--carotene-color-palette-blue-300)",
    blue400: "var(--carotene-color-palette-blue-400)",
    blue500: "var(--carotene-color-palette-blue-500)",
    blue600: "var(--carotene-color-palette-blue-600)",
    blue700: "var(--carotene-color-palette-blue-700)",
    blue800: "var(--carotene-color-palette-blue-800)",
    blue900: "var(--carotene-color-palette-blue-900)",
    blue1000: "var(--carotene-color-palette-blue-1000)",
    red100: "var(--carotene-color-palette-red-100)",
    red200: "var(--carotene-color-palette-red-200)",
    red300: "var(--carotene-color-palette-red-300)",
    red400: "var(--carotene-color-palette-red-400)",
    red500: "var(--carotene-color-palette-red-500)",
    red600: "var(--carotene-color-palette-red-600)",
    red700: "var(--carotene-color-palette-red-700)",
    red800: "var(--carotene-color-palette-red-800)",
    red900: "var(--carotene-color-palette-red-900)",
    red1000: "var(--carotene-color-palette-red-1000)",
    green100: "var(--carotene-color-palette-green-100)",
    green200: "var(--carotene-color-palette-green-200)",
    green300: "var(--carotene-color-palette-green-300)",
    green400: "var(--carotene-color-palette-green-400)",
    green500: "var(--carotene-color-palette-green-500)",
    green600: "var(--carotene-color-palette-green-600)",
    green700: "var(--carotene-color-palette-green-700)",
    green800: "var(--carotene-color-palette-green-800)",
    green900: "var(--carotene-color-palette-green-900)",
    green1000: "var(--carotene-color-palette-green-1000)",
    yellow100: "var(--carotene-color-palette-yellow-100)",
    yellow200: "var(--carotene-color-palette-yellow-200)",
    yellow300: "var(--carotene-color-palette-yellow-300)",
    yellow400: "var(--carotene-color-palette-yellow-400)",
    yellow500: "var(--carotene-color-palette-yellow-500)",
    yellow600: "var(--carotene-color-palette-yellow-600)",
    yellow700: "var(--carotene-color-palette-yellow-700)",
    yellow800: "var(--carotene-color-palette-yellow-800)",
    yellow900: "var(--carotene-color-palette-yellow-900)",
    yellow1000: "var(--carotene-color-palette-yellow-1000)",
    purple100: "var(--carotene-color-palette-purple-100)",
    purple200: "var(--carotene-color-palette-purple-200)",
    purple300: "var(--carotene-color-palette-purple-300)",
    purple400: "var(--carotene-color-palette-purple-400)",
    purple500: "var(--carotene-color-palette-purple-500)",
    purple600: "var(--carotene-color-palette-purple-600)",
    purple700: "var(--carotene-color-palette-purple-700)",
    purple800: "var(--carotene-color-palette-purple-800)",
    purple900: "var(--carotene-color-palette-purple-900)",
    purple1000: "var(--carotene-color-palette-purple-1000)",
    staticWhite: "var(--carotene-color-palette-static-white)",
    staticWhiteAlpha50: "var(--carotene-color-palette-static-white-alpha-50)",
    staticWhiteAlpha200: "var(--carotene-color-palette-static-white-alpha-200)",
    staticBlack: "var(--carotene-color-palette-static-black)",
    staticBlackAlpha50: "var(--carotene-color-palette-static-black-alpha-50)",
    staticBlackAlpha200: "var(--carotene-color-palette-static-black-alpha-200)",
    staticBlackAlpha500: "var(--carotene-color-palette-static-black-alpha-500)"
  }
};

// src/duration.ts
var duration = {
  1: "var(--carotene-duration-1)",
  2: "var(--carotene-duration-2)",
  3: "var(--carotene-duration-3)",
  4: "var(--carotene-duration-4)",
  5: "var(--carotene-duration-5)",
  6: "var(--carotene-duration-6)",
  7: "var(--carotene-duration-7)",
  8: "var(--carotene-duration-8)",
  9: "var(--carotene-duration-9)",
  10: "var(--carotene-duration-10)"
};

// src/gradient.ts
var gradient = {
  solid: "var(--carotene-gradient-solid)"
};

// src/keyframes.ts
var keyframes = {
  enter: "carotene-enter",
  exit: "carotene-exit"
};

// src/radius.ts
var radius = {
  0: 0,
  0.5: "var(--carotene-radius-0\\.5)",
  1: "var(--carotene-radius-1)",
  1.5: "var(--carotene-radius-1\\.5)",
  2: "var(--carotene-radius-2)",
  2.5: "var(--carotene-radius-2\\.5)",
  3: "var(--carotene-radius-3)",
  4: "var(--carotene-radius-4)",
  5: "var(--carotene-radius-5)",
  6: "var(--carotene-radius-6)",
  7: "var(--carotene-radius-7)",
  8: "var(--carotene-radius-8)",
  10: "var(--carotene-radius-10)",
  12: "var(--carotene-radius-12)",
  16: "var(--carotene-radius-16)",
  20: "var(--carotene-radius-20)",
  24: "var(--carotene-radius-24)",
  32: "var(--carotene-radius-32)",
  full: "var(--carotene-radius-full)"
};

// src/shadow.ts
var shadow = {
  default: "var(--carotene-shadow-default)"
};

// src/size.ts
var size = {
  0: 0,
  0.5: "var(--carotene-size-0\\.5)",
  1: "var(--carotene-size-1)",
  1.5: "var(--carotene-size-1\\.5)",
  2: "var(--carotene-size-2)",
  2.5: "var(--carotene-size-2\\.5)",
  3: "var(--carotene-size-3)",
  4: "var(--carotene-size-4)",
  5: "var(--carotene-size-5)",
  6: "var(--carotene-size-6)",
  7: "var(--carotene-size-7)",
  8: "var(--carotene-size-8)",
  10: "var(--carotene-size-10)",
  12: "var(--carotene-size-12)",
  16: "var(--carotene-size-16)",
  20: "var(--carotene-size-20)",
  24: "var(--carotene-size-24)",
  32: "var(--carotene-size-32)",
  full: "100%"
};

// src/spacing.ts
var spacing = {
  0: 0,
  0.5: "var(--carotene-spacing-0\\.5)",
  1: "var(--carotene-spacing-1)",
  1.5: "var(--carotene-spacing-1\\.5)",
  2: "var(--carotene-spacing-2)",
  2.5: "var(--carotene-spacing-2\\.5)",
  3: "var(--carotene-spacing-3)",
  4: "var(--carotene-spacing-4)",
  5: "var(--carotene-spacing-5)",
  6: "var(--carotene-spacing-6)",
  7: "var(--carotene-spacing-7)",
  8: "var(--carotene-spacing-8)",
  10: "var(--carotene-spacing-10)",
  11: "var(--carotene-spacing-11)",
  12: "var(--carotene-spacing-12)",
  16: "var(--carotene-spacing-16)",
  20: "var(--carotene-spacing-20)",
  24: "var(--carotene-spacing-24)",
  32: "var(--carotene-spacing-32)"
};

// src/timingFunction.ts
var timingFunction = {
  linear: "var(--carotene-timing-function-linear)",
  standard: "var(--carotene-timing-function-standard)",
  enter: "var(--carotene-timing-function-enter)",
  exit: "var(--carotene-timing-function-exit)"
};

// src/typography.ts
var fontSize = {
  50: "var(--carotene-font-size-50)",
  75: "var(--carotene-font-size-75)",
  100: "var(--carotene-font-size-100)",
  200: "var(--carotene-font-size-200)",
  300: "var(--carotene-font-size-300)",
  400: "var(--carotene-font-size-400)",
  500: "var(--carotene-font-size-500)"
};
var lineHeight = {
  "heading.xsmall": "var(--carotene-heading-line-height-xsmall)",
  "heading.small": "var(--carotene-heading-line-height-small)",
  "heading.medium": "var(--carotene-heading-line-height-medium)",
  "heading.large": "var(--carotene-heading-line-height-large)",
  "heading.xlarge": "var(--carotene-heading-line-height-xlarge)",
  "body.xxsmall": "var(--carotene-body-line-height-xxsmall)",
  "body.xsmall": "var(--carotene-body-line-height-xsmall)",
  "body.small": "var(--carotene-body-line-height-small)",
  "body.medium": "var(--carotene-body-line-height-medium)",
  "body.large": "var(--carotene-body-line-height-large)"
};
var fontWeight = {
  regular: "var(--carotene-font-weight-regular)",
  semibold: "var(--carotene-font-weight-semibold)",
  bold: "var(--carotene-font-weight-bold)"
};

// src/uniformHeight.ts
var uniformHeight = {
  small: "var(--carotene-uniform-height-small)",
  medium: "var(--carotene-uniform-height-medium)",
  large: "var(--carotene-uniform-height-large)"
};

// src/zIndex.ts
var zIndex = {
  0: 0,
  1: 1,
  2: 2,
  sticky: "var(--carotene-z-index-sticky)",
  modal: "var(--carotene-z-index-modal)",
  notification: "var(--carotene-z-index-notification)"
};

// src/index.ts
var vars = {
  borderWidth,
  color,
  radius,
  spacing,
  size,
  uniformHeight,
  fontSize,
  fontWeight,
  lineHeight,
  duration,
  timingFunction,
  keyframes,
  gradient,
  shadow,
  zIndex
};
export {
  vars
};
//# sourceMappingURL=index.mjs.map
